import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import HomePageClassicImpl from './home-page-classic.js';

const UIPage = MojitoCore.Presentation.UIPage;

/**
 * @namespace HomePageClassic
 * @memberof Mojito.Applications.Sports.Pages
 */

/**
 * Classic design style home page.
 *
 * @class HomePageClassic
 * @extends Mojito.Core.Presentation.UIPage
 * @memberof Mojito.Applications.Sports.Pages.HomePageClassic
 */

/**
 * HomePageClassic prop types.
 *
 * @property {boolean} [showQuickStartGuide = false] - Flag to render the Quick Start Guide component on the home page.
 *
 * @memberof Mojito.Applications.Sports.Pages.HomePageClassic
 */
const propTypes = {
    showQuickStartGuide: PropTypes.bool,
};

const defaultProps = {
    showQuickStartGuide: false,
};

export default UIPage('HomePageClassic', HomePageClassicImpl, propTypes, defaultProps);
